import { createStyles } from '@mantine/core';

export const useDashboardStyles = createStyles(theme => ({
  scroll: {
    overflowY: 'scroll',
  },
  layout: {
    padding: theme.spacing.xl,
    margin: 'auto',
    display: 'grid',
    maxWidth: '1000px',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'auto',
    gridTemplateAreas: `
      "banner banner"
      "metrics metrics "
      "accounting payments"
      "athletes athletes"
      "utilization reservations"
      "package category"
      "attendance birthdays"
      `,
    alignItems: 'start',
    gap: theme.spacing.sm,
    [theme.fn.smallerThan('md')]: {
      maxWidth: '100vw',
      padding: theme.spacing.sm,
      gridTemplateColumns: 'auto',
      gridTemplateAreas: `
        'banner'
        'metrics'
        'accounting'
        'payments'
        'athletes'
        'utilization'
        'reservations'
        'package'
        'category'
        'attendance'
        'birthdays'
        `,
    },
  },
  banner: {
    gridArea: 'banner',
  },
  metrics: {
    gridArea: 'metrics',
  },
  accounting: {
    gridArea: 'accounting',
  },
  payments: {
    gridArea: 'payments',
  },
  athletes: {
    gridArea: 'athletes',
  },
  utilization: {
    gridArea: 'utilization',
  },
  package: {
    gridArea: 'package',
  },
  category: {
    gridArea: 'category',
  },
  attendance: {
    gridArea: 'attendance',
  },
  birthdays: {
    gridArea: 'birthdays',
  },
  reservations: {
    gridArea: 'reservations',
  },
  card: {
    whiteSpace: 'nowrap',
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.md,
    boxShadow: theme.shadows.lg,
    backgroundColor: 'white',
    [theme.fn.smallerThan('sm')]: {
      whiteSpace: 'break-spaces',
    },
  },
  cardHeader: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing.sm,
  },
  label: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize: theme.fontSizes.md,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: theme.colors.gray[6],
  },
  value: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  valueText: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  clickableCard: {
    ...theme.fn.hover({
      background: theme.colors.gray[0],
      boxShadow: theme.shadows.lg,
      color: theme.colors.kiloBlue[5],
      cursor: 'pointer',

      '*': {
        color: theme.colors.kiloBlue[5],
      },
    }),
  },
}));
